import api, { requestApi } from '@/api'
import getCurrentUserId from '@/utils/get-current-user-id'

export const ERROR_AUTH_FAILED = 'auth_failed'
export const ERROR_BUG = 'bug'
export const ERROR_NEED_ACTION = 'actionNeeded'
export const ERROR_NEED_ADDITIONAL = 'additionalInformationNeeded'
export const ERROR_NONE = 'none'
export const ERROR_SCRAPPING_FAILED = 'scrapping_failed'
export const ERROR_WEBSITE_UNAVAILABLE = 'websiteUnavailable'
export const ERROR_WRONGPASS = 'wrongPass'

export default {
  add (bankId, fields, token, host) {
    const biApi = requestApi(host)
    const options = Object.assign({}, {idBank: bankId}, fields)

    // axios has common defaults.headers between instances bug so we do not store token, use it in one-shot query
    return biApi({
      method: 'post',
      url: '/2.0/users/me/connections?expand=accounts',
      data: options,
      headers: {Authorization: `Bearer ${token}`}
    })
  },

  updatePassword (connexionId, password, token, host) {
    const biApi = requestApi(host)

    return biApi({
      method: 'post',
      url: `/2.0/users/me/connections/${connexionId}`,
      data: { password },
      headers: {Authorization: `Bearer ${token}`}
    })
  },

  addLoading (data) {
    return api.post('/users/me/accounts', { accounts: data })
  },

  delete (id) {
    return api.delete(`/accounts/${id}`)
  },

  fetch () {
    return api.get(`/users/${getCurrentUserId()}/accounts`)
  },

  fetchById (id) {
    return api.get(`/users/${getCurrentUserId()}/accounts/${id}`)
  },

  fetchRepartition () {
    return api.get(`/users/${getCurrentUserId()}/portfolios/composition?type=bank&subset=wealth`)
  },
  updateContract (portfolioId, data) {
    return api.put(`/portfolios/${portfolioId}`, data)
  },

  synchronize (accountId) {
    return api.post(`/accounts/${accountId}/synchronize`)
  }
}
